import { Button } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import { StyledLoading } from './index.styled'

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
}

const Loading = ({ className, size = 'md' }: Props) => {
  const { formatMessage: f } = useIntl()
  const loadingText = f({
    id: 'player.loading',
    defaultMessage: 'Loading',
  })
  return (
    <StyledLoading className={className}>
      <Button size={size} color="transparent" isLoading>
        {loadingText}
      </Button>
    </StyledLoading>
  )
}

export { Loading }
